import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RemindersTodaySmartComponent } from './reminders-today-smart/reminders-today-smart.component';
import { RemindersTodayComponent } from './reminders-today/reminders-today.component';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatCardModule } from '@angular/material/card';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    RemindersTodaySmartComponent,
    RemindersTodayComponent
  ],
  imports: [
    CommonModule,
    MatBadgeModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatMenuModule,
    RouterModule
  ],
  exports: [
    RemindersTodaySmartComponent
  ],
})
export class RemindersTodayModule { }
